import { OpsiumUserShortResponse } from '@/modules/common';
import { OpsiumUserShort } from '@/modules/common/types/opsium-user';

/**
 * Maps opsium user short DTO to application type.
 */
export const mapOpsiumUserShortFromDTO = (dto: OpsiumUserShortResponse): OpsiumUserShort => {
  return {
    id: dto.id,
    email: dto.email,
    name: dto.name,
    profileImageUrl: dto.profileImageUrl,
    isDeleted: dto.isDeleted,
  };
};
/**
 * Maps opsium user short DTO from application type to DTO .
 */
export const mapOpsiumUserShortToDTO = (user: OpsiumUserShort): OpsiumUserShortResponse => {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    profileImageUrl: user.profileImageUrl,
    isDeleted: user.isDeleted,
  };
};
